import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@mui/material";

import { CopyIcon } from "../../../assets/img/svg/CopyIcon";

import { CopyButton } from "./ButtonCopy.styled";

export const ButtonCopy = ({ text, addStyles }) => {
  const { t } = useTranslation();
  const [tooltipText, setTooltipText] = useState(t("global.copy"));

  const handleCopyClick = () => {
    if (window.isSecureContext) {
      navigator.clipboard.writeText(text);
      setTooltipText(t("global.copied"));
      setTimeout(() => {
        setTooltipText(t("global.copy"));
      }, 2000);
    }
  };
  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <CopyButton addStyles={addStyles} onClick={handleCopyClick}>
        <CopyIcon />
      </CopyButton>
    </Tooltip>
  );
};
